import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import { Container, Row, Col, Button } from "react-bootstrap";
import LogoService from "../../services/logo.service";
import { ArrowClockwise} from 'react-bootstrap-icons';
import LogoButton from "../LogoButton";


const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const UploadLogo = ({ register, fieldName, title, currentLogo, bgColor, setFile, width, showThumbs }) => {
  const hiddenInputRef = useRef();
  const { ref: registerRef } = register(fieldName);

  // Handle both string URLs and objects with imageUrl property
  const getImageUrl = (logo) => {
    if (!logo) return null;
    if (typeof logo === 'string') return logo;
    return logo.imageUrl || null;
  };

  const imageUrl = getImageUrl(currentLogo);

  const [xsImg, setXsImg] = useState(imageUrl ? BACKEND_URL + LogoService.getThumbUrl(imageUrl, "xs") : null);
  const [smImg, setSmImg] = useState(imageUrl ? BACKEND_URL + LogoService.getThumbUrl(imageUrl, "sm") : null);

  const getPreviewUrl = () => {
    if (!imageUrl) return null;
    if (imageUrl.indexOf("uploads") > -1) {
      return BACKEND_URL + imageUrl;
    }
    return BACKEND_URL + "/uploads/subsites/" + imageUrl;
  };

  const [preview, setPreview] = useState(getPreviewUrl());

  const handleUploadedFile = (event) => {
    const file = event.target.files[0];
    console.log("FILE", file);
    setFile(file);
    const urlImage = URL.createObjectURL(file);

    setPreview(urlImage);
  };


  const generateThumbnails = async (filename) => {
    await LogoService.generateThumbs(filename);
    setXsImg(xsImg + "?" + new Date().getTime());
    setSmImg(smImg + "?" + new Date().getTime());
  }

  return (
    <Container fluid style={{ backgroundColor: bgColor ? bgColor : "#000000", color: "#FFFFFF" }} >
      <Row>
        <Col>
          <Form.Label className="sectionTitle">{title}</Form.Label>
        </Col>
      </Row>
      {imageUrl && (
        <Row>
          <Col>
            Current Image: {showThumbs && <LogoButton style={{ color: "blue" }} size="25" Icon={ArrowClockwise} tooltip="Generate Thumbnails" onClick={() => generateThumbnails(imageUrl)} />}
            <br />
            <p className="sectionTitle" style={{ border: "1px solid #999999" }}>Normal<br />
              <img src={BACKEND_URL + imageUrl} alt="Old logo image" height="100" /><br />
            </p>
            {showThumbs &&
              <>
                <p className="sectionTitle" style={{ border: "1px solid #999999" }}>Small<br />
                  <img src={smImg} alt="SM logo image" height="100" /><br /></p>
                <p className="sectionTitle" style={{ border: "1px solid #999999" }}>XSmall<br />
                  <img src={xsImg} alt="XS logo image" height="20" /><br /></p>
              </>}
          </Col>
        </Row>
      )}
      <Row>
        <Col style={{ padding: 15 }}>
          <input
            type="file"
            accept="image/*,.png,.jpg,.jpeg"
            id={fieldName}
            name={fieldName}
            {...register(fieldName)}
            onChange={handleUploadedFile}
            ref={(e) => {
              registerRef(e);
              hiddenInputRef.current = e;
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col style={{ padding: 15 }}>
          {preview && <Image src={preview} alt="logo image" style={{ width: width ? width : 100 }} />}
        </Col>
      </Row>
    </Container>
  );
};

export default UploadLogo;
